import { COLORS, RADIUS, SHADOWS, FONTS, fontFamilyFor } from "../../../theme";

const fontFor = (isArabic) => fontFamilyFor(isArabic ? "ar" : "en");

export const Style = {
  main: {
    maxWidth: { xs: "300px", sm: "400px" },
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center !important",
  },
  firstChild: {
    display: { xs: "none", sm: "flex" },
    gap: "20px",
    alignItems: "baseline",
  },
  icon: { width: "28px", height: "28px", cursor: "pointer" },
  heading: (isArabic) => ({
    ml: "45px",
    color: "var(--White, #FFF)",
    fontFamily: fontFor(isArabic),
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "normal",
    mb: "24px",
    width: "100%",
    display: { xs: "flex", sm: "none" },
  }),
  ticketCard: {
    display: "flex",
    width: "100%",
    background: COLORS.forest,
    borderRadius: RADIUS.card,
    overflow: "hidden",
    boxShadow: SHADOWS.card,
    border: "1px solid rgba(255,255,255,0.08)",
    position: "relative",
    my: "8px",
  },
  ticketCardBody: (isArabic) => ({
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: isArabic ? "flex-end" : "flex-start",
    textAlign: isArabic ? "right" : "left",
    gap: "6px",
    padding: "22px 18px",
  }),
  admitOneLabel: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    fontSize: "10px",
    fontWeight: 700,
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    color: COLORS.peach,
  }),
  ticketEventName: (isArabic) => ({
    fontFamily: isArabic ? fontFor(isArabic) : FONTS.heading,
    fontSize: "19px",
    fontWeight: 700,
    color: COLORS.white,
    lineHeight: 1.25,
  }),
  ticketMetaLine: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    fontSize: "12px",
    fontWeight: 600,
    letterSpacing: "0.3px",
    color: "rgba(255,255,255,0.65)",
  }),
  ticketLocation: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    fontSize: "12px",
    color: "rgba(255,255,255,0.5)",
  }),
  ticketQty: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    fontSize: "13px",
    fontWeight: 700,
    color: COLORS.peach,
    mt: "6px",
  }),
  ticketStub: {
    width: "104px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px",
    position: "relative",
    borderInlineStart: "2px dashed rgba(255,255,255,0.25)",
  },
  ticketQrImg: {
    width: "78px",
    height: "78px",
    background: COLORS.white,
    borderRadius: RADIUS.input,
    padding: "6px",
    boxSizing: "border-box",
    objectFit: "contain",
  },
  ticketNotch: (position) => ({
    position: "absolute",
    [position]: "-10px",
    insetInlineEnd: "94px",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    background: COLORS.dark,
    zIndex: 1,
  }),
  orderNumber: (isArabic) => ({
    fontFamily: fontFor(isArabic),
    fontSize: "13px",
    color: "rgba(255,255,255,0.45)",
    textAlign: "center",
    mt: "12px",
  }),
  ticketId: {
    lineHeight: { xs: "30px", sm: "40px" },
    fontSize: { xs: "12px", sm: "16px" },
    fontWeight: "800",
  },
  userDetailContainer: (isArabic) => ({
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    mt: "16px",
    width: "100%",
    maxWidth: "380px",
    wordBreak: "break-all",
    fontFamily: fontFor(isArabic),
    color: COLORS.white,
    textAlign: isArabic ? "right" : "left",
  }),
  seatContainer: (isArabic) => ({
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    mt: "10px",
    width: "100%",
    maxWidth: "380px",
    borderTop: "1px dashed rgba(255,255,255,0.2)",
    pt: "10px",
    fontFamily: fontFor(isArabic),
    textAlign: isArabic ? "right" : "left",
  }),
  organizationName: (isArabic) => ({
    mt: "16px",
    color: COLORS.grey,
    fontFamily: fontFor(isArabic),
    fontSize: "12px",
    fontWeight: 600,
  }),
};
